import React from 'react';
import { Input } from '@flixbus/honeycomb-react';

import { Asterisk } from '../../Asterisk';
import { useVoucherFormContext } from '../../Context';

import useOnMount from '../../../../hooks/useInit';

const MIN_PERCENTAGE = 0;
const MAX_PERCENTAGE = 100;
const KEYBOARD_STEP = 5;

const VoucherFormPercentageMarketing = () => {
  const DEFAULT_DISCOUNT_TYPE = {
    type: 'percentage_marketing',
    percentage: 0.3,
  };

  const {
    formState: {
      payload: { discountType },
    },
    handlePayloadChange,
  } = useVoucherFormContext();

  useOnMount(() => handlePayloadChange({ value: DEFAULT_DISCOUNT_TYPE, prop: 'discountType' }));

  const currentPercentage = discountType.percentage
    ? parseFloat((discountType.percentage * 100).toFixed(10))
    : 0;

  const setPercentage = (value: number) => {
    handlePayloadChange({
      value: {
        type: 'percentage_marketing',
        percentage: value / 100,
      },
      prop: 'discountType',
    });
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;

    e.preventDefault();
    const next =
      e.key === 'ArrowUp'
        ? Math.min(
            MAX_PERCENTAGE,
            Math.floor(currentPercentage / KEYBOARD_STEP) * KEYBOARD_STEP + KEYBOARD_STEP,
          )
        : Math.max(
            MIN_PERCENTAGE,
            Math.ceil(currentPercentage / KEYBOARD_STEP) * KEYBOARD_STEP - KEYBOARD_STEP,
          );

    setPercentage(next);
  };

  return (
    <div>
      <Input
        name='percentage-marketing'
        id='percentage-marketing'
        label={
          <>
            Percentage <Asterisk />
          </>
        }
        type='number'
        step={1}
        max={MAX_PERCENTAGE}
        min={MIN_PERCENTAGE}
        required
        value={currentPercentage.toString()}
        onKeyDown={handleKeyDown}
        onChange={e => {
          const parsedValue = e.target.value === '' ? 0 : parseFloat(e.target.value);
          const finalValue = isNaN(parsedValue)
            ? 0
            : Math.min(Math.max(parsedValue, 0), MAX_PERCENTAGE);

          setPercentage(finalValue);
        }}
      />
    </div>
  );
};

export default VoucherFormPercentageMarketing;
